import { ReactElement, useCallback, useState } from 'react';

import { DisplayableMessage } from '@dreryk/egabinet-patient-frontend-api';

import { PatientCannotBeRemovedModal } from './PatientCannotBeRemovedModal';

type PatientCannotBeRemovedModalOpenerPropsRenderProps = {
   openModal: (displayableMessage: DisplayableMessage) => void;
};
type PatientCannotBeRemovedModalOpenerProps = {
   readonly children: (renderProps: PatientCannotBeRemovedModalOpenerPropsRenderProps) => ReactElement;
};

export const PatientCannotBeRemovedModalOpener = (props: PatientCannotBeRemovedModalOpenerProps): JSX.Element => {
   const [displayableMessage, setDisplayableMessage] = useState<DisplayableMessage | null>(null);

   const handleClose = useCallback(() => {
      setDisplayableMessage(null);
   }, []);

   return (
      <>
         {props.children({ openModal: setDisplayableMessage })}
         {displayableMessage ? (
            <PatientCannotBeRemovedModal onClose={handleClose} displayableMessage={displayableMessage} />
         ) : null}
      </>
   );
};
